import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Config from './Config';
import Common from './Common';
// import RaceCountdown from './RaceCountdown';
// import races from '../data/races.json';

import './libs/daijima/trace.js';
import './libs/daijima/requestanimationframe.js';

import '../scss/common.scss';
import '../scss/top.scss';
import '../scss/enjoy.scss';
import '../scss/feature.scss';
import '../scss/tyre_tech.scss';
import '../scss/sustainability.scss';
import '../scss/session_atc0.scss';

//CSS Modulesとして使用する場合
// import * as styles from "../scss/common.scss";

Config.getInstance();
new Common();

// 9/30公開時点ではカウントダウン自体を一旦停止（表示側は_fixedSidebar.pug/
// index.pugのhero__timerをコメントアウト済み — [data-timer]が無くても
// update()はsetIntervalを回し続けてしまうため、起動自体を止める）
// const countdown = new RaceCountdown(races);
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => countdown.start(), {
//     once: true,
//   });
// } else {
//   countdown.start();
// }
